import React from 'react';
import './style.css';

export const Apartment  = ()=> <i className="icon-apartment" />;
export const Balcony  = ()=> <i className="icon-balcony" />;
export const Bank  = ()=> <i className="icon-bank" />;
export const Bath  = ()=> <i className="icon-bath" />;
export const Bicycle  = ()=> <i className="icon-bicycle" />;
export const Book  = ()=> <i className="icon-book" />;
export const Building  = ()=> <i className="icon-building" />;
export const Bus  = ()=> <i className="icon-bus" />;
export const Check  = ()=> <i className="icon-check" />;
export const Clinic  = ()=> <i className="icon-clinic" />;
export const Coffee  = ()=> <i className="icon-coffee" />;
export const Extra  = ()=> <i className="icon-check" />;
export const Film  = ()=> <i className="icon-film" />;
export const Hospital  = ()=> <i className="icon-hospital" />;
export const Juridic  = ()=> <i className="icon-judicial" />;
export const Laptop  = ()=> <i className="icon-laptop" />;
export const Internet  = ()=> <i className="" />;
export const Office  = ()=> <i className="icon-office" />;
export const Pet  = ()=> <i className="icon-pet" />;
export const Phone  = ()=> <i className="icon-phone" />;
export const Restaurant  = ()=> <i className="icon-restaurant" />;
export const Sale  = ()=> <i className="icon-sale" />;
export const School  = ()=> <i className="icon-schools" />;
export const Security  = ()=> <i className="icon-security" />;
export const Store  = ()=> <i className="icon-store" />;
export const Supermarket  = ()=> <i className="icon-supermarket" />;
export const Water  = ()=> <i className="icon-water" />;
export const Floor  = ()=> <i className="icon-floor" />;
export const Heating  = ()=> <i className="icon-heating" />;
export const House  = ()=> <i className="icon-house" />;
export const Parking  = ()=> <i className="icon-parking" />;
export const Price  = ()=> <i className="icon-price" />;
export const Rooms  = ()=> <i className="icon-rooms" />;
export const Spending  = ()=> <i className="icon-spending" />;
export const Surface  = ()=> <i className="icon-surface" />;
export const Depot  = ()=> <i className="icon-depot" />;
export const Industrial  = ()=> <i className="icon-industrial" />;
export const Site  = ()=> <i className="icon-site" />;
export const Agro  = ()=> <i className="icon-agro" />;
export const Process  = ()=> <i className="icon-process" />;
export const Connected  = ()=> <i className="icon-connected" />;
export const Disconnected  = ()=> <i className="icon-disconnected" />;
export const ClasiQuote  = ()=> <i className="icon-clasi-quote" />;
export const ChartTeam  = ()=> <i className="icon-chart-team" />;
export const ChartProperties  = ()=> <i className="icon-chart-properties" />;
export const ChartTansactions  = ()=> <i className="icon-chart-transactions" />;
export const ChartYears  = ()=> <i className="icon-chart-years" />;
export const View360  = ()=> <i className="icon-degrees" />;
export const Video  = ()=> <i className="icon-video" />;
